import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { OverlayProps } from 'components/SingleTooltip';
import SubmitButton from 'shared/components/SubmitButton';
import MoneyView from 'shared/components/MoneyView';
import { Money } from 'shared/types/common';
import { useCancelMutation } from './hooks';

import './index.scss';
import { Investment_IdeaType } from 'types/common';

export interface Props extends OverlayProps {
  orderId: number;
  amount: Money;
  ideaType: Investment_IdeaType;
  ideaId?: number;
}

const b = b_.with('order-card-cancel-tooltip');

export const CancelTooltip: React.FC<Props> = ({ orderId, ideaType, ideaId, amount, close }) => {
  const { t } = useTranslation();
  const { cancel, loading, error } = useCancelMutation(orderId, ideaType, ideaId);
  return (
    <div className={b()} data-testid="cancel-tooltip">
      <p data-testid="question">
        {t('Are you sure that you want to cancel the order and withdraw')}{' '}
        <MoneyView maximumFractionDigits={2}>{amount}</MoneyView> {t('to the main account')}
      </p>
      <div className={b('buttons')}>
        <SubmitButton
          onClick={cancel}
          submitting={loading}
          error={error}
          primary
          data-testid="cancel-btn"
        >
          {t('Withdraw investment')}
        </SubmitButton>
        <button className={b('cancel-btn')} onClick={close} data-testid="close-btn">
          {t('Do not withdraw investment')}
        </button>
      </div>
    </div>
  );
};
